import React from "react";
import EventEmitter from "../../../../../eventEmmiters/EventEmitter";
import axios from "axios";
import API from "../../../../../utils/api";
import Loader from "../../../loader/loader";
import FormElementGenerator from "../../form-elements/formElementGenerator";

class Utf8DisabledToolProfileForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            utfToolProfileId: null,
            ltiToolProfileCode: '',
            ltiToolProfileDescription: '',
            utf16: false,
            createdDate: '',
            modifiedDate: '',
            isDisplayLoader: true,

            errors: {},
            // user token
            token: '',
            // form fields
            fields: [
                {
                    inputType: 'text',
                    labelName: 'Tool Code',
                    inputName: 'ltiToolProfileCode',
                    placeholder: '',
                    required: true,
                    disabled: true
                },
                {
                    inputType: 'text',
                    labelName: 'Tool Profile Description',
                    inputName: 'ltiToolProfileDescription',
                    placeholder: '',
                    required: true,
                    disabled: true
                },
                {
                    inputType: 'text',
                    labelName: 'Created Date',
                    inputName: 'createdDate',
                    placeholder: '',
                    required: true,
                    disabled: true
                },
                {
                    inputType: 'text',
                    labelName: 'Modified Date',
                    inputName: 'modifiedDate',
                    placeholder: '',
                    required: true,
                    disabled: true
                }
            ]
        };

        EventEmitter.emit('setPageHeaderData', {
            page: 'utf8EnabledToolProfile',
            pageName: "UTF8 Tool Profile",
            pageLink: process.env.REACT_APP_BASE_URL + "/#/home/utf8EnabledToolProfile",
            optionalIcons: ['backIcon', 'deleteIcon']
        });

        // set event emitters
        EventEmitter.on('displayDeleteFormDataWarning', this.displayDeleteWarningMessage);
        EventEmitter.on('deleteFormData', this.deleteToolProviders);
        EventEmitter.on('navigateToPreviousPage', this.navigateToPreviousPage);
    }

    // set a token to unsubscribe the async call
    CancelToken = axios.CancelToken;
    source = this.CancelToken.source();

    componentDidMount = async () => {
        // get parameter from URL
        const utfToolProfileId = this.props.match.params.id;
        console.log("Utf8DisabledToolProfileForm")
        console.log(utfToolProfileId)

        // get token
        const user = JSON.parse(localStorage.getItem('tmcUser'));
        const token = 'Bearer ' + user.token;

        const oldState = Object.assign({}, this.state);

        // fill the form if not a create utf8EnabledToolProfile
        if (utfToolProfileId !== undefined) {
            const cancelToken = axios.CancelToken;
            const src = cancelToken.source();

            const url = '/utf8EnabledToolProfile?search=%7Butf8EnabledToolProfileId:' + utfToolProfileId + '%7D';

            await API.get(url, {headers: {Authorization: token}}).then(res => {
                const data = res.data[0];
                oldState.utfToolProfileId = utfToolProfileId;
                oldState.ltiToolProfileCode = (data.ltiToolProfile.code !== undefined) ? data.ltiToolProfile.code : '';
                oldState.ltiToolProfileDescription = (data.ltiToolProfile.description !== undefined) ? data.ltiToolProfile.description : '';
                oldState.utf16 = (data.utf16 !== undefined) ? data.utf16 : '';
                oldState.createdDate = (data.createdDate !== undefined) ? data.createdDate : '';
                oldState.modifiedDate = (data.modifiedDate !== undefined) ? data.modifiedDate : '';
                oldState.token = token;
                oldState.isDisplayLoader = false;

                this.setState(oldState);
            }).catch(er => {
                oldState.isDisplayLoader = false;
                this.setState(oldState);
                this.displayErrorsForAPICalls(er);
            });

            src.cancel();
        } else {
            oldState.token = token;
            oldState.isDisplayLoader = false;
            this.setState(oldState);
        }
    };

    componentWillUnmount = () => {
        // remove all configured event emitters
        EventEmitter.off('setPageHeaderData', {});
        EventEmitter.off('displayDeleteFormDataWarning', this.displayDeleteWarningMessage);
        EventEmitter.off('deleteFormData', this.deleteToolProviders);
        EventEmitter.off('navigateToPreviousPage', this.navigateToPreviousPage);
    };

    deleteToolProviders = async (data) => {
        if (data && (this.props.match.path === "/home/utf8EnabledToolProfile/:id")) {
            this.setState({isDisplayLoader: true});
            await API.delete('/utf8EnabledToolProfile?enabledProfileId=' + this.state.utfToolProfileId, {headers: {Authorization: this.state.token}, cancelToken: this.source.token})
                .then(res => {
                    this.setState({isDisplayLoader: false});
                    this.props.history.push('/home/utf8EnabledToolProfile');
                    this.setAlert("Success", "Success", "Successfully Disabled the UTF8 Encoding!");
                }).catch(er => {
                    this.setState({isDisplayLoader: false});
                    this.displayErrorsForAPICalls(er);
                });
        }
    };

    displayDeleteWarningMessage = () => {
        console.log("Utf8DisabledToolProfileForm.displayDeleteWarningMessage")
        if (this.state.utfToolProfileId !== null) {
            EventEmitter.emit('warningModelData', {
                type: 'utf8EnabledToolProfile',
                name: '(disable) UTF8 encoding for this Tool Code'
            });
            EventEmitter.emit('openWarningModel', true);
        } else {
            EventEmitter.emit('setAlert', {
                openAlert: true,
                type: "Error",
                isDisplayAlertIcon: true,
                alertMessage: "You are trying to delete before loading the Data",
                alertTitle: "Error"
            });
        }

    };


    displayErrorsForAPICalls = (error) => {
        this.setAlert("Error", "Error", "Something went wrong!");
    };

    /**
     * fire an alert
     * @param alertType
     * @param alertTitle
     * @param alertMessage
     */
    setAlert = (alertType, alertTitle, alertMessage) => {
        EventEmitter.emit('setAlert', {
            openAlert: true,
            type: alertType,
            isDisplayAlertIcon: true,
            alertMessage: alertMessage,
            alertTitle: alertTitle
        });
    };

    /**
     * navigate to previous page
     */
    navigateToPreviousPage = () => {
        this.props.history.push('/home/utf8EnabledToolProfile');
    };

    render() {
        return(
            <div role="form" className="container">
                {this.state.isDisplayLoader && <Loader/>}
                {this.state.isDisabled &&
                    <div className="main-btn-container">
                        <div className="buttons" tooltip="Change to Running" onClick={this.handleSubmit}>
                            <i className="fa fa-check-circle fa-lg icon-primary"/>
                        </div>
                    </div>
                }
                <form>
                    <FormElementGenerator currentState={this.state} handleChange={null} />
                </form>
            </div>
        )
    }
}

export default Utf8DisabledToolProfileForm;
